module.exports = __webpack_public_path__ + "img/gaoxin_second.4b86cda4.png";